import React from 'react';
import PropTypes from 'prop-types';

import Box from '@quintoandar/cozy-core/Box';

import TimelineDay from './TimelineDay';

const sortByDay = items =>
  items.slice().sort((a, b) => a.date.getTime() - b.date.getTime());

const separateItemsByTime = (itemsGroupedByDate, item) => {
  const timeIndependentItems = itemsGroupedByDate[item].items.filter(
    itemToFilter => !itemToFilter.timeDependent,
  );

  const timeDependentItems = itemsGroupedByDate[item].items.filter(
    itemToFilter => itemToFilter.timeDependent,
  );

  return {
    timeIndependent: timeIndependentItems,
    timeDependent: sortByDay(timeDependentItems),
  };
};

const sortItems = itemsGroupedByDate =>
  Object.keys(itemsGroupedByDate).map(item => {
    const { timeIndependent, timeDependent } = separateItemsByTime(
      itemsGroupedByDate,
      item,
    );

    return {
      date: itemsGroupedByDate[item].date,
      items: [...timeIndependent, ...timeDependent],
    };
  });

const groupByDate = items =>
  items.reduce((itemsGroupedByDate, scheduledItem) => {
    const scheduledItemDateString = scheduledItem.date.toDateString();
    const itemsGrouped = itemsGroupedByDate[scheduledItemDateString]
      ? itemsGroupedByDate[scheduledItemDateString].items.concat(scheduledItem)
      : [scheduledItem];

    return {
      ...itemsGroupedByDate,
      [scheduledItemDateString]: {
        date: scheduledItem.date,
        items: itemsGrouped,
      },
    };
  }, {});

export const Timeline = ({ scheduledItems }) => {
  const itemsGroupedByDate = groupByDate(scheduledItems);
  const sortedItems = sortItems(itemsGroupedByDate);
  const sortedByDay = sortByDay(sortedItems);

  return (
    <Box>
      {sortedByDay.map(day => <TimelineDay key={day.date.toJSON()} {...day} />)}
    </Box>
  );
};

Timeline.propTypes = {
  scheduledItems: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.instanceOf(Date),
      timeDependent: PropTypes.bool,
      label: PropTypes.string,
      ContentComponent: PropTypes.node,
    }),
  ).isRequired,
};

export default Timeline;
